"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadStatus = void 0;
var PadStatus;
(function (PadStatus) {
    PadStatus["Online"] = "Online";
    PadStatus["Unlocked"] = "Unlocked";
    PadStatus["Offline"] = "Offline";
    PadStatus["Locked"] = "Locked";
    PadStatus["Provisioned"] = "Provisioned";
    PadStatus["Unprovisioned"] = "Unprovisioned";
    PadStatus["Idle"] = "Idle";
    PadStatus["Loading"] = "Loading...";
    PadStatus["NoSiteSelected"] = "No Site Selected";
})(PadStatus = exports.PadStatus || (exports.PadStatus = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/pad.ts
// module id = 2806
// module chunks = 0 1